import React from 'react';
import {
  compose,
  withProps,
} from 'recompose';
import {
  addItemToArray,
  removeItemArrayByIndex,
  removeItemArrayById,
  updateItemArrayByIndex,
} from 'helpers/arrayHelpers';

import { updateDeepKey } from 'helpers/objectHelpers';

export const withCollection = ({
  dataSet, // if no dataSet provide, use dataSet from prop
  idKey = 'id',
  onAddDataSet = (dataSet) => dataSet,
  useDataSetFromProp = false,
}) => compose(
  withProps(
    ({ dataSet:propDataSet, collection, onUpdate, onRawChange = () => {} }) => {
      // dataSet can be inject from params or props or both(use param as default)
      // dataSet should not be empty string => Dataset will be undefined
      const DataSet = useDataSetFromProp ? propDataSet : (dataSet || propDataSet);
      return {
        onReplaceItemByIndex: (index, newItem) => {
          return onUpdate(updateItemArrayByIndex(
            collection,
            index,
            (item) => newItem
          ))
        },
        onUpdateStringByIndex: (index, val) => {
          return onUpdate(updateItemArrayByIndex(
            collection,
            index,
            () => val,
          ))
        },
        onUpdateItemByIndex: (index, val, ...keys) => {
          return onUpdate(updateItemArrayByIndex(
            collection,
            index,
            (item) => updateDeepKey(item, val, ...keys)
          ))
        },
        onAddToLast: () => {
          return onUpdate(
            [ ...collection, onAddDataSet(DataSet) ]
          )
        },
        onAddAfterIndex: (index) => onUpdate(
          addItemToArray(collection, onAddDataSet(DataSet), index)
        ),
        onDeleteById: (id) => {
          const newData = removeItemArrayById(collection, id, idKey)
          onRawChange(newData)
          onUpdate(newData)
        },
        onDeleteByIndex: (index) => {
          const newData = removeItemArrayByIndex(collection, index)
          onRawChange(newData)
          onUpdate(newData)
        },
        onDuplicateToLast: (originalDataSet) => onUpdate(
          [ ...collection, DataSet ]
        ),
        onDuplicateAfterIndex: (originalDataSet, index) => onUpdate(
          addItemToArray(collection, originalDataSet, index)
        )
      }
    }
  )
);




// WEBPACK FOOTER //
// ./src/hocs/bases/withCollection.js